import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=19b1ef59"
import script from "./ImageField.vue?vue&type=script&lang=js"
export * from "./ImageField.vue?vue&type=script&lang=js"
import style0 from "./ImageField.vue?vue&type=style&index=0&id=19b1ef59&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports